// extracted by mini-css-extract-plugin
module.exports = {"form":"ReportingModal_form__1FwSw","formLine":"ReportingModal_formLine__IcHEv","dropdown":"ReportingModal_dropdown__35wH6"};